import { Loader2, Sparkles } from 'lucide-react'

interface ArtifactStateOverlayProps {
  isRegenerating: boolean
  hasContent: boolean
  label: string
  hint?: string
}

/**
 * Overlay reutilizável para estado de regeneração nos viewers de artefato.
 *
 * - Quando `isRegenerating && !hasContent` → ocupa todo o painel com skeleton
 *   centralizado (primeira geração).
 * - Quando `isRegenerating && hasContent`  → aparece como pílula no canto
 *   superior, sinalizando atualização sem esconder a versão atual.
 */
export default function ArtifactStateOverlay({
  isRegenerating,
  hasContent,
  label,
  hint,
}: ArtifactStateOverlayProps) {
  if (!isRegenerating) return null

  if (!hasContent) {
    return (
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-20 bg-white/60 dark:bg-gray-950/60 backdrop-blur-sm">
        <div className="flex flex-col items-center gap-3 px-6 py-5 rounded-xl border border-violet-200 dark:border-violet-800 bg-white/90 dark:bg-gray-900/90 shadow-lg max-w-xs text-center">
          <div className="w-10 h-10 rounded-full bg-violet-100 dark:bg-violet-900/40 flex items-center justify-center">
            <Loader2 size={20} className="text-violet-600 dark:text-violet-300 animate-spin" />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-900 dark:text-white">{label}</p>
            {hint && <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{hint}</p>}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="absolute top-3 right-3 z-20 pointer-events-none flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium bg-violet-100/95 dark:bg-violet-900/40 text-violet-700 dark:text-violet-200 border border-violet-200 dark:border-violet-800 shadow-sm backdrop-blur-sm">
      <Loader2 size={11} className="animate-spin" />
      <Sparkles size={10} className="opacity-60" />
      Atualizando versão
    </div>
  )
}
